import "./DesktopDashboard.css";
import { useMemo, useState } from "react";

export default function WithdrawPanel({ options = [], loading = false, onSubmit = () => {} }) {
  const [amount, setAmount] = useState("");
  const [selected, setSelected] = useState(null);
  const [fieldValues, setFieldValues] = useState({});
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const opts = useMemo(() => options || [], [options]);

  const currentFields = selected?.inputFields || [];

  const handleSubmit = async () => {
    setStatus("");
    setError("");
    if (!selected) {
      setError("Select a method and enter amount.");
      return;
    }
    try {
      setSubmitting(true);
      await onSubmit({
        providerType: selected.type,
        fields: fieldValues
      });
      setStatus("Withdraw request sent.");
    } catch (err) {
      setError(err?.message || "Failed to submit withdraw.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="table-card withdraw-card">
      <div className="withdraw-head">
        <div>
          <h3>Withdraw</h3>
          <p className="text-muted">Enter amount and choose a payment option.</p>
        </div>
      </div>

      {/* <div className="wizard-field">
        <label>Withdraw Amount</label>
        <input
          type="number"
          min="0"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="0.00"
        />
      </div> */}

      {currentFields.length > 0 && (
        <div className="withdraw-dynamic">
          {currentFields.map((f) => (
            <div className="wizard-field" key={f.key}>
              <label>{f.inputName}{f.isMandatoryInput ? " *" : ""}</label>
              <input
                type={f.inputType === "double" ? "number" : f.inputType || "text"}
                placeholder={f.placeholder}
                value={fieldValues[f.key] || ""}
                onChange={(e) =>
                  setFieldValues((prev) => ({ ...prev, [f.key]: e.target.value }))
                }
              />
              {f.nonInputErrorMessage && (
                <small className="text-muted">{f.nonInputErrorMessage}</small>
              )}
            </div>
          ))}
        </div>
      )}

      <div className="withdraw-options">
        {loading && <div className="table-loading">Loading withdraw options...</div>}
        {!loading && opts.length === 0 && (
          <div className="table-loading">No withdraw options available.</div>
        )}
        {!loading && opts.map((opt) => (
          <div
            key={opt.type}
            className={`withdraw-option ${selected?.type === opt.type ? "is-active" : ""}`}
            style={{ border: opt.borderStyle || undefined, background: "#fff" }}
            onClick={() => setSelected(opt)}
          >
            <div className="withdraw-option-top">
              {opt.image && <img src={opt.image} alt={opt.name} />}
              <div>
                <div className="withdraw-name">{opt.name}</div>
                <div className="withdraw-meta">{opt.timePeriod}</div>
              </div>
              <div className="withdraw-min">Min: ${opt.minWithdrawAmount}</div>
            </div>
            {opt.providerInfo && <div className="withdraw-info">{opt.providerInfo}</div>}
          </div>
        ))}
      </div>

      <div className="withdraw-actions">
        <button
          className="pill-btn teal"
          onClick={handleSubmit}
          disabled={submitting || !selected}
        >
          {submitting ? "Submitting..." : "Withdraw"}
        </button>
        {(status || error) && (
          <div className={`withdraw-status ${error ? "is-error" : ""}`}>
            {error || status}
          </div>
        )}
      </div>
    </section>
  );
}
